import { LitElement, css, html, unsafeCSS } from "lit";
import { property } from "lit/decorators.js";
import styles from "./styles.css?inline";
import { template } from "./template";

export class PrimariaErrorView extends LitElement {
  render() {
    return html`${template(this)}`;
  }

  static styles = css`
  ${unsafeCSS(styles)}
`;

  @property()
  error: { message: string };
}
